import styled from '@emotion/styled';
import { theme } from '../../../theme/theme';

interface TextSmallMediumProps {
  lineHeight?: React.CSSProperties['lineHeight'];
  textAlign?: React.CSSProperties['textAlign'];
  color?: React.CSSProperties['color'];
  children: React.ReactNode;
}

export function TextSmallMedium(props: TextSmallMediumProps) {
  return (
    <S.Root
      style={{
        '--text-small-medium-line-height': props.lineHeight,
        '--text-small-medium-text-align': props.textAlign,
        '--text-small-medium-color': props.color,
      }}
    >
      {props.children}
    </S.Root>
  );
}

interface CSSProperties {
  '--text-small-medium-line-height'?: TextSmallMediumProps['lineHeight'];
  '--text-small-medium-text-align'?: TextSmallMediumProps['textAlign'];
  '--text-small-medium-color'?: TextSmallMediumProps['color'];
}

const S = (TextSmallMedium.S = class S {
  static Root = styled.div<{ style: CSSProperties }>`
    font-size: ${theme.fontSize.small};
    font-weight: ${theme.fontWeight.medium};
    line-height: var(--text--small-medium-line-height, 20px);
    text-align: var(--text-small-medium-text-align, start);
    color: var(--text-small-medium-color, ${theme.color.text});
  `;
});
